// reducers/inventoryReducer.js
export const inventoryReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case "INVENTORY_REQUEST":
      return { ...state, loading: true };
    case "GET_INVENTORY_SUCCESS":
      return { loading: false, items: action.payload };
    case "CREATE_INVENTORY_SUCCESS":
    case "UPDATE_INVENTORY_SUCCESS":
      return { loading: false, success: true };
    case "INVENTORY_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
